import { render, staticRenderFns } from "./FormContacts.vue?vue&type=template&id=d38d9ed0"
import script from "./FormContacts.vue?vue&type=script&lang=js"
export * from "./FormContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports